/* ==========================================================================
   Crumpaw · announcement bar — auto-advance

   Advances the message track on an interval read from the section settings.
   Vanilla, no dependencies, and inert unless the section says to rotate.

   Auto-updating text needs a way to stop, so this pauses on hover, on focus
   within the bar, and while the tab is in the background, and it never starts
   for a visitor who has asked for reduced motion.
   ========================================================================== */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function start(bar) {
    if (bar.dataset.cpAnnounceInit === 'on') return;
    bar.dataset.cpAnnounceInit = 'on';

    var list = bar.querySelector('.cp-announce__list');
    if (!list) return;
    var items = list.querySelectorAll('.cp-announce__item');
    if (items.length < 2) return;

    var seconds = parseFloat(bar.getAttribute('data-cp-rotate-seconds')) || 5;
    var query = bar.getAttribute('data-cp-rotate-query') || '(max-width: 749px)';
    var media = window.matchMedia(query);
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');

    var index = 0;
    var timer = null;
    var paused = false;

    var show = function (i) {
      index = (i + items.length) % items.length;
      bar.style.setProperty('--cp-announce-index', String(index));
      for (var n = 0; n < items.length; n++) {
        /* Only the message on screen should be reachable by a screen reader
           or the keyboard; the others are off to the side. */
        items[n].setAttribute('aria-hidden', n === index ? 'false' : 'true');
      }
    };

    var stop = function () {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    var run = function () {
      stop();
      if (paused || !media.matches || still.matches) return;
      timer = window.setInterval(function () {
        if (!document.hidden) show(index + 1);
      }, Math.max(2, seconds) * 1000);
    };

    var setPaused = function (value) {
      paused = value;
      run();
    };

    var apply = function () {
      if (media.matches) {
        bar.setAttribute('data-cp-rotate', 'on');
        show(index);
      } else {
        bar.removeAttribute('data-cp-rotate');
        bar.style.removeProperty('--cp-announce-index');
        for (var n = 0; n < items.length; n++) items[n].removeAttribute('aria-hidden');
      }
      run();
    };

    apply();

    if (media.addEventListener) media.addEventListener('change', apply);
    else if (media.addListener) media.addListener(apply);
    if (still.addEventListener) still.addEventListener('change', run);

    bar.addEventListener('pointerenter', function () { setPaused(true); });
    bar.addEventListener('pointerleave', function () { setPaused(false); });
    bar.addEventListener('focusin', function () { setPaused(true); });
    bar.addEventListener('focusout', function () { setPaused(false); });
    document.addEventListener('visibilitychange', run);
  }

  function boot() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.cp-announce[data-cp-rotate-seconds]'), start);
  }

  ready(boot);
  document.addEventListener('shopify:section:load', boot);
})();
